import React from 'react'
import { Grid, GridCell, Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { AdminWorkspace24Icon, ArrowDownIcon, LogoOutline24Icon, ProfileOutline24Icon,
   LogoutOutline24Icon } from 'assets/icons'
import Popover from 'src/sites/kits/Utils/Popover'
import { useMe, useOrganization } from 'src/core/graphql/hooks'

// TODO: Move this to seperate file when more sure
// PR #757
const ToolsBlockButton = ({ icon, name, onClick }) => (
   <View onClick={onClick} textAlign="center" margin="10px 0px">
      <View
         display="inline-flex"
         justifyContent="center"
         alignItems="center"
         height="30px"
         width="30px"
         marginBottom="10px">
         {icon}
      </View>
      <Text color="#888" size="1">
         {name}
      </Text>
   </View>
)

ToolsBlockButton.propTypes = {
   icon: PropTypes.node.isRequired,
   name: PropTypes.string.isRequired,
   onClick: PropTypes.func
}

ToolsBlockButton.defaultProps = {
   onClick: undefined
}

const ToolsBlock = ({
   popoverAnchorOriginHorizontal,
   popoverAnchorOriginVertical,
   popoverMargin
}) => {
   const { me, isLoggedIn } = useMe()
   const { organization } = useOrganization()
   const isAdmin = organization.currentUserCanEdit
   const isGatherDeveloper = me?.email.endsWith('@mother.co')

   if (!isLoggedIn) {
      return null
   }

   return (
      <Popover.Provider>
         <Popover.Anchor>
            <View
               flex="0 0 auto"
               display="flex"
               justifyContent="flex-end"
               alignItems="center"
               width="30px"
               height="30px"
               paddingRight="3px"
               borderRadius="2px">
               <ArrowDownIcon
                  width="12px"
                  height="12px"
                  color="#777"
                  strokeWidth="2px"
               />
            </View>
         </Popover.Anchor>
         <Popover.View
            anchorOriginHorizontal={popoverAnchorOriginHorizontal}
            anchorOriginVertical={popoverAnchorOriginVertical}
            margin={popoverMargin}
            width="280px">
            <View
               position="relative"
               bottom="-2px"
               right="-5px"
               float="left"
               width="100%"
               borderRadius="6px"
               margin="5px 0px"
               boxShadow="3px 3px 20px rgba(0,0,0,0.2)"
               backgroundColor="rgba(18,18,20,0.98)">
               <View float="left" width="100%" padding="10px">
                  <Grid columns="3" spacing="5px">
                     <GridCell>
                        <Link to="/-/profile">
                           <ToolsBlockButton
                              icon={(
                                 <ProfileOutline24Icon
                                    width="20px"
                                    height="20px"
                                    color="#ccc"
                                 />
                              )}
                              name="Profile"
                           />
                        </Link>
                     </GridCell>
                     {isGatherDeveloper && (
                        <GridCell>
                           <Link to="/-/library">
                              <ToolsBlockButton
                                 icon={(
                                    <LogoOutline24Icon
                                       width="20px"
                                       height="20px"
                                       color="#ccc"
                                    />
                                 )}
                                 name="Library"
                              />
                           </Link>
                        </GridCell>
                     )}
                     <GridCell>
                        <Link to={isAdmin ? '/-/admin' : '/-/profile/me/settings'}>
                           <ToolsBlockButton
                              icon={(
                                 <AdminWorkspace24Icon
                                    width="22px"
                                    height="22px"
                                    color="#ccc"
                                 />
                              )}
                              name={isAdmin ? 'Admin Workspace' : 'Account Settings'}
                           />
                        </Link>
                     </GridCell>
                     <GridCell>
                        <Link to="/account/logout">
                           <ToolsBlockButton
                              icon={(
                                 <LogoutOutline24Icon
                                    width="20px"
                                    height="20px"
                                    color="#ccc"
                                 />
                              )}
                              name="Logout"
                           />
                        </Link>
                     </GridCell>
                  </Grid>
               </View>
            </View>
         </Popover.View>
      </Popover.Provider>
   )
}

ToolsBlock.propTypes = {
   popoverAnchorOriginHorizontal: PropTypes.oneOf(['left', 'right']),
   popoverAnchorOriginVertical: PropTypes.oneOf(['bottom', 'top']),
   popoverMargin: PropTypes.string
}

ToolsBlock.defaultProps = {
   popoverAnchorOriginHorizontal: 'right',
   popoverAnchorOriginVertical: 'bottom',
   popoverMargin: '0px'
}

export default ToolsBlock
